import { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

/**
 * مؤشر حالة الاتصال - يظهر شريط أحمر عند انقطاع الإنترنت،
 * ورسالة خضراء سريعة عند عودة الاتصال.
 */
export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!online) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-[9999] bg-[#ff453a] text-white text-center py-2 text-sm font-bold shadow-lg flex items-center justify-center gap-2 animate-pulse"
        data-testid="offline-indicator"
      >
        <WifiOff className="w-4 h-4" />
        لا يوجد اتصال بالإنترنت • تعمل في وضع غير متصل (البيانات قد تكون قديمة)
      </div>
    );
  }

  if (showReconnected) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-[9999] bg-[#34c759] text-white text-center py-2 text-sm font-bold shadow-lg flex items-center justify-center gap-2"
        data-testid="online-indicator"
      >
        <Wifi className="w-4 h-4" />
        عاد الاتصال • تم تحديث البيانات
      </div>
    );
  }

  return null;
}
